import Vue from 'vue';
import Router from 'vue-router';
import { OktaAuth } from '@okta/okta-auth-js';
import OktaVue from '@okta/okta-vue';
import { LoginCallback } from '@okta/okta-vue';
import SignatureGenerator from '../components/SignatureGenerator';
const { VUE_APP_CLIENT_ID, VUE_APP_ISSUER } = process.env;

const oktaAuth = new OktaAuth({
  issuer: VUE_APP_ISSUER,
  clientId: VUE_APP_CLIENT_ID,
  redirectUri: `/login/callback`,
  scopes: ['openid', 'profile', 'email']
});

Vue.use(Router);
Vue.use(OktaVue, { oktaAuth });

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login/callback',
      component: LoginCallback,
      name: 'redirect'
    },
    {
      path: '/',
      component: SignatureGenerator,
      name: 'signature',
      meta: {
        requiresAuth: true
      }
    }
  ]
});
